var FormStorage = (function() {
	var __private = {
		franchise: "franchise_type",

		create(form) {
			if(form instanceof HTMLFormElement) {
				let key  = form.id || "formStorage";
				let data = {};

				for (let i = 0; i < form.elements.length; i++) {
					const el = form.elements[i];

					if(el.type !== "hidden" && el.type !== "button" && el.type !== "submit") {
						data[i] = {
							name : el.name,
							value: el.value
						};

						if(el.type === "radio" || el.type === "checkbox") {
							data[i].checked = el.checked;
						}
					}
				}

				localStorage.setItem(key, JSON.stringify(data));
			}
		},

		remove(key = "formStorage") {
			delete localStorage[key];
		},

		download(form) {
			if(form instanceof HTMLFormElement) {
				let key  = form.id || "formStorage";
				let data = JSON.parse(localStorage.getItem(key));

				if(data !== null) {
					for (const key in data) {
						if (data.hasOwnProperty(key)) {
							const d     = data[key];
							const name  = d.name;
							const value = d.value;
							const check = d.checked;

							if(check === undefined) {
								let elem = form.querySelector(`*[name='${name}']`);
								if(elem instanceof HTMLElement) elem.value = value;

								// for FRANCHISE
								if(name === __private.franchise) {
									let elems = form.querySelectorAll(`*[name='${name}']`);
									setTimeout(() => {
										for (let i = 0; i < elems.length; i++) {
											elems[i].value = value;
										}
									}, 300);
								}
							} else {
								let elem = form.querySelector(`input[name='${name}'][value='${value}']`);
								if(elem instanceof HTMLInputElement && (elem.type === "radio" || elem.type === "checkbox"))
									elem.checked = check;
							}
						}
					}
				}
			}
		}
	};

	return {
		create(form) {
			if(form instanceof HTMLFormElement) __private.create(form);
			else throw new Error("Form is not valid");
		},

		remove(form) {
			if(form instanceof HTMLFormElement && form.id) __private.remove(form.id);
			else __private.remove();
		},

		download(form) {
			if(form instanceof HTMLFormElement) __private.download(form);
			else throw new Error("Form is not valid");
		}
	};
})();


// Run
(function() {
	document.addEventListener("DOMContentLoaded", function() {

		/*
		var registerForm = document.getElementById("c-registration-form");

		if(registerForm instanceof HTMLFormElement) {
			FormStorage.download(registerForm);

			registerForm.addEventListener("click" , function() { FormStorage.create(registerForm); });
			registerForm.addEventListener("change", function() { FormStorage.create(registerForm); });
		}
		*/

	});
})();